// Cookie consent utility for GDPR compliance
// Manages the qate_cookie_consent cookie (strictly necessary — stores user's privacy preference)

const COOKIE_NAME = 'qate_cookie_consent';
const COOKIE_VERSION = 1;
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year in seconds

function parseCookie() {
  try {
    const match = document.cookie.match(
      new RegExp('(?:^|;\\s*)' + COOKIE_NAME + '=([^;]*)')
    );
    if (!match) return null;
    return JSON.parse(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
}

export function getConsent() {
  const consent = parseCookie();
  if (!consent || consent.version !== COOKIE_VERSION) return null;
  return consent;
}

export function setConsent({ analytics, marketing }) {
  const value = {
    version: COOKIE_VERSION,
    timestamp: new Date().toISOString(),
    necessary: true,
    analytics: !!analytics,
    marketing: !!marketing,
  };
  const encoded = encodeURIComponent(JSON.stringify(value));
  document.cookie = `${COOKIE_NAME}=${encoded}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  return value;
}

export function hasConsent(category) {
  const consent = getConsent();
  if (!consent) return false;
  if (category === 'necessary') return true;
  return consent[category] === true;
}

export function hasConsentDecision() {
  return getConsent() !== null;
}

export function revokeConsent() {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
}
